import { AlertColor } from "@mui/material";
import {
	ReactNode,
	createContext,
	useCallback,
	useMemo,
	useState,
} from "react";

export type OpenNotificationType = {
	type?: AlertColor;
	message?: string;
	isOpen?: boolean;
};

export interface NotificationContextData {
	openNotification: ({ message, type }: OpenNotificationType) => void;
	closeNotification: () => void;
	isOpen: boolean;
	message: string;
	type: AlertColor;
}

export const NotificationsContext = createContext(
	{} as NotificationContextData,
);

interface NotificationsProviderProps {
	children: ReactNode;
}

export const NotificationsProvider = ({
	children,
}: NotificationsProviderProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [type, setType] = useState<AlertColor>("info");

	const openNotification = useCallback(
		({ message, type }: OpenNotificationType) => {
			setIsOpen(true);
			setMessage(message ?? "Ocorreu um erro inesperado.");
			setType(type ?? "info");
		},
		[],
	);

	const closeNotification = useCallback(() => {
		setIsOpen(false);
	}, []);

	const valuesContext = useMemo(() => {
		return {
			openNotification,
			closeNotification,
			isOpen,
			message,
			type,
		};
	}, [isOpen, message, type]);

	return (
		<NotificationsContext.Provider value={valuesContext}>
			{children}
		</NotificationsContext.Provider>
	);
};
